export const colors = {
  white: '#ffffff',
  black: '#000000',
  blue: '#345d96',
  green: '#4d8055',
  yellow: '#fad980',
  darkGrey: '#333333',
  mediumGrey: '#dddddd',
  lightGrey: '#f6f6f6',
};

export const breakpoints = {
  small: `(min-width: 320px)`,
  mediumMax: `(max-width: 767px)`,
  medium: `(min-width: 768px)`,
  largeMax: `(max-width: 899px)`,
  large: `(min-width: 900px)`,
  fullMax: `(max-width: 1023px)`,
  full: `(min-width: 1024px)`,
};

export const font = {
  family: "'Public Sans', 'Helvetica Neue', Arial, sans-serif",
  bodyCopySize: '16px',
  bodyCopyLineHeight: 1.625,
};

export const layout = {
  maxWidth: '1200px',
  maxWidthNarrow: '600px',
  maxWidthMedium: '900px',
  maxWidthLarge: '1100px',
  maxWidthWide: '1400px',
  maxWidthFull: '1700px',
  minPadding: '15px',
  maxPadding: '20px',
};

export const zIndex = {
  modal: 1000,
  skipLinks: 999,
  header: 900,
  nav: 899,
};
